import React, {Component} from 'react';
import {Navbar,Nav, NavDropdown,FormControl,Button,Form} from 'react-bootstrap';


class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: ''
    };
  }
  searchProduct = () => {
    console.log("In Search");
    console.log("this.state.value: "+this.state.searchTerm);

  }
  changeHandler = (event) => {
    this.setState({searchTerm: event.target.value});
  }
    render (){
   
        return (   
         
                           
            <Navbar bg="light" expand="lg">
            <Navbar.Brand href="/"><img src="/shopmuthu-logo.png" width="170px" heigh ="70px" alt="shopmuthu.com logo"/></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto">
                <Nav.Link href="/">Home</Nav.Link>
                <Nav.Link href="/category/mobiles">Mobiles</Nav.Link>
                <Nav.Link href="/category/games">Games</Nav.Link>
                <Nav.Link href="/category/books">Books</Nav.Link>
                <NavDropdown title="others" id="basic-nav-dropdown">
                  <NavDropdown.Item href="#action/3.1">Electronics</NavDropdown.Item>
                  <NavDropdown.Item href="#action/3.2">Baby Products</NavDropdown.Item>
                  <NavDropdown.Item href="#action/3.3">Laptops</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href="#action/3.4">TV</NavDropdown.Item>
                </NavDropdown>
              </Nav>
              <Form inline action={`/search/${this.state.searchTerm}`} >
                <FormControl type="text" placeholder="Search" id="searchTerm"   className="mr-sm-2"  onChange={this.changeHandler}/>                
                <input type="submit" value="Submit" className="btn btn-primary" />
              </Form>
            </Navbar.Collapse>
          </Navbar>
    
       

        );
    }
}


export default Navigation;